import * as React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderContainer } from '../Header';
import { SearchResultContainer } from '../SearchResult';
import { PaginationContainer } from '../Pagination';
import { useOpenDeveloperCatalogUxfbEvent } from '../../hooks/uxfb';

export function PageContainer(): React.JSX.Element {
  useOpenDeveloperCatalogUxfbEvent();

  return (
    <PageLayout
      header={<HeaderContainer />}
      searchResult={<SearchResultContainer />}
      pagination={<PaginationContainer />}
    />
  );
}
